import app from 'flarum/common/app';

app.initializers.add('foskym/flarum-sorts-for-user-directory', () => {
  console.log('[foskym/flarum-sorts-for-user-directory] Hello, forum and admin!');
});
